import { useEffect } from "react";
import { PatchService } from "src/services/patch-service";
import { usePatchStore } from "src/services/patch-ecosystem-store";
import { PatchHeaderSection, PatchContentSection, PatchFooter, PatchNavbar } from "src/views";
import { SetPageTitle } from "src/helpers/set-page-title";

function PatchPage() {
  const { setChampionDB, setHardCounterChampionDB, setDefaultComps, setPatchInfo, patchInfo } =
    usePatchStore();

  useEffect(() => {
    getPatchInfo();
  }, []);

  useEffect(() => {
    SetPageTitle(patchInfo.patch);
  }, [patchInfo]);

  const getChampionDB = async () => {
    const tierlistInfo = await PatchService.getChampionDB();
    setChampionDB(tierlistInfo.JSON_STRING_CHAMPIONS);
    setHardCounterChampionDB(tierlistInfo.JSON_STRING_HARD_COUNTERS);
    setDefaultComps(tierlistInfo.JSON_PROCOMPS_SPECIALS);
  };

  const getPatchInfo = async () => {
    const latestPatchInfo = await PatchService.getPatchInfo();

    if (latestPatchInfo.patch !== patchInfo.patch) {
      setPatchInfo(latestPatchInfo);
      getChampionDB();
    }
  };

  return (
    <div className="min-h-screen min-w-fit bg-[#000605]">
      <div className="box-border min-h-screen  bg-[#000605]">
        <PatchNavbar />
        <PatchHeaderSection />
        <PatchContentSection />
        <PatchFooter />
      </div>
    </div>
  );
}

export default PatchPage;
